import { gql } from "@apollo/client";

export const myLensesPreviewMediaFragment = gql`
    fragment MyLensesPreviewMedia on MyLensesPreviewMedia {
        mediaId
        thumbnailMediaUrl
        thumbnailMediaPosterUrl
        standardMediaUrl
        standardMediaPosterUrl
    }
`;
